<template>
    <div class="app-container">
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1749015789538" class="icon" viewBox="0 0 1063 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4561" width="26" height="26"><path d="M248.32 148.992z" fill="#cdcdcd" p-id="4562"></path><path d="M765.44 939.008l-415.744-425.472 416.256-415.744c9.728-9.728 9.728-25.6 0-35.328s-25.6-9.728-35.328 0l-432.128 435.2c-9.728 9.728-9.728 25.6 0 35.328l432.128 441.856c9.728 9.728 25.6 9.728 35.328 0 9.216-10.24 9.216-26.112-0.512-35.84z" p-id="4563" fill="#cdcdcd"></path></svg>
                </div>
                <div class="right-head-container">创建教学分析</div>
            </div>
            <!--基本信息-->
            <div class="info-container">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <div class="info-column-container">
                        <div class="column-title">基本信息</div>
                    </div>
                    <div class="info-content-container">
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                基础信息
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="文件上传" prop="videoFile">
                                    <el-upload ref="upload"
                                               style="width: 100%"
                                               class="upload-demo"
                                               :auto-upload="true"
                                               :limit="1"
                                               drag
                                               accept=".MP4,.mp4,"
                                               :before-upload="handleBeforeUpload"
                                               :http-request="handleCourseUpload">
                                        <div class="el-upload__text">
                                            将文件拖拽到此处或<em>点击上传</em>
                                        </div>
                                        <template #tip>
                                            <div class="el-upload__tip">
                                                只允许上传一个MP4格式文件,且大小不超过4G。
                                            </div>
                                        </template>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="视频名称" prop="taskName">
                                    <el-input v-model="form.taskName" placeholder="请输入视频名称，最多50个字" maxlength="50" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="授课教师" prop="lectureTeacher">
                                    <choosePeople :showTitle="'选择授课教师'"
                                                  :radio="true"
                                                  ref="lectureTeacher" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="学段" prop="periodId">
                                    <el-select  @change="changePeriod" v-model="form.periodId" placeholder="请选择学段">
                                        <el-option v-for="item in periodList" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="学科" prop="subjectId">
                                    <el-select @change="changeSubject" v-model="form.subjectId" placeholder="请选择学科">
                                        <el-option v-for="item in subjectList" :key="item.id" :label="item.title" :value="item.id" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="10">
                                <el-form-item label="量表" prop="scaleId">
                                    <el-select @change="changeScale" v-model="form.scaleId" placeholder="请选择量表">
                                        <el-option v-for="item in scaleList" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="授课语言" prop="language">
                                    <el-radio-group v-model="form.language">
                                        <el-radio :label="'0'">中文</el-radio>
                                        <el-radio :label="'1'">English</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="备注信息" prop="remark">
                                    <el-input type="textarea" rows="6" v-model="form.remark"/>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </div>
                </el-form>
            </div>

        </div>


        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:215px;'">
                <el-button @click="backList">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 认</el-button>
            </div>
        </div>

        <div class="loading-overlay" v-if="loadingVisible">
            <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="8"></el-progress>
            <p class="tips_css">上传中，请等待...</p>
        </div>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import choosePeople from "@/components/choosePeople.vue";
import {getFileNameUUID, signatureUrl} from "@/utils/tools";
import {listPeriod,listSubject,listScale,createCourseTask} from "@/api/admin/courseAnalyse"


let OSS = require('ali-oss');
let client = new OSS({
    region: 'oss-cn-beijing',    //创建的时候，bucket所在的区域，华北2->oss-cn-beijing ；其他的可以去百度
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',// 阿里云控制台创建的AccessKey
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1', //阿里云控制台创建的AccessSecret
    bucket: 'free-back'  //创建的bucket的名称
})
/*分片大小*/
const SHARD_SIZE_CONFIG = {
    SMALL: 1, // < 200MB
    MEDIUM: 2, // < 1024MB
    LARGE: 5, // < 2048MB
    X_LARGE_RATIO: 500 // >= 2048MB
};

export default {
    name: "courseAnalyseCreate",
    components: {choosePeople},
    data() {
        return {
            serviceUrl,
            periodList: [],
            subjectList: [],
            scaleList:[],
            userList: [],
            token: this.$storage.get("token"),
            // 遮罩层
            loading: false,
            loadingVisible: false,//开启遮罩
            fileList:[],
            loadingPercentage: 0,
            // 表单校验
            form: {
                taskName:'',
                userId:'',
                periodId:'',
                periodName:'',
                subjectId:'',
                subjectName:'',
                scaleId:'',
                scaleName:'',
                fileName:'',
                fileSize:'',
                language:'0',
                videoUrl:'',
                orgId:'system_teaching',
                businessType:0,
                remark:'',
            },
            scaleForm:{
                periodId:'',
                subjectId:'',
            },
            rules: {
                videoFile: { required: true, validator: this.checkCourseFile },
                taskName: [{ required: true, message: "请输入视频名称", trigger: "blur" },],
                lectureTeacher: { required: true, validator: this.checkLectureTeacher },
                periodId: [{ required: true, message: "请选择学段", trigger: "change" },],
                subjectId: [{ required: true, message: "请选择学科", trigger: "change" },],
                scaleId: [{ required: true, message: "请选择量表", trigger: "change" },],
                language: [{ required: true, message: "请选择授课语言", trigger: "change" },],
            },
            partItemSize:5,
        };
    },
    created() {
        this.queryPeriodList();
        this.querySubjectList();
    },
    mounted() {
        if (this.$route.query.raceId) {
            this.raceId = this.$route.query.raceId
            if (this.raceId!==''){
                this.queryRaceInfo()
            }
        } else {
            this.isShow = true
        }
    },
    unmounted() {},
    computed: {},
    methods: {
        queryPeriodList(){
            listPeriod().then(res => {
                if (res.data.code===1){
                    this.periodList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        changePeriod(){
            this.form.scaleId = '';
            this.form.scaleName = '';
            this.periodList.forEach(item => {
                if (this.form.periodId === item.id) {
                    this.form.periodName = item.name;
                }
            })

            if (this.form.periodId&&this.form.subjectId){
                this.scaleForm.periodId = this.form.periodId;
                this.scaleForm.subjectId = this.form.subjectId;
                this.queryScaleList()
            }
        },
        querySubjectList(){
            listSubject().then(res => {
                if (res.data.code===1){
                    this.subjectList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        changeSubject(){
            this.form.scaleId = '';
            this.form.scaleName = '';
            this.subjectList.forEach(item => {
                if (this.form.subjectId === item.id) {
                    this.form.subjectName = item.title;
                }
            })

            if (this.form.periodId&&this.form.subjectId){
                this.scaleForm.periodId = this.form.periodId;
                this.scaleForm.subjectId = this.form.subjectId;
                this.queryScaleList()
            }
        },
        queryScaleList(){
            listScale(this.scaleForm).then(res => {
                if (res.data.code===1){
                    this.scaleList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        changeScale(){
            this.scaleList.forEach(item => {
                if (this.form.scaleId === item.id) {
                    this.form.scaleName = item.name;
                }
            })
        },
        handleBeforeUpload(rawFile){
            console.log("视频大小："+rawFile.size)
            if (!(rawFile.type === 'video/mp4')) {
                this.$message.error('不支持此类型文件')
                return false
            } else if (rawFile.size / 1024/1024/1024 > 4) {
                this.$message.error('文件大小不能超过4G')
                return false
            }
            this.form.fileSize = rawFile.size
            let fs = rawFile.size / 1024/1024;
            this.partItemSize = this.calcShardSize(fs);
            console.log("动态分片大小："+this.partItemSize);
            return true
        },
        calcShardSize(fileSize) {
            if (fileSize < 200) return SHARD_SIZE_CONFIG.SMALL;   // 1MB
            else if (fileSize < 1024) return SHARD_SIZE_CONFIG.MEDIUM; // 2MB
            else if (fileSize < 2048) return SHARD_SIZE_CONFIG.LARGE;  // 5MB
            else return Math.ceil(fileSize / SHARD_SIZE_CONFIG.X_LARGE_RATIO); // 动态分片
        },
        handleCourseUpload(option) {
            // 文件后缀
            var fileType = this.getFileName(option.file.name);
            // 获取文件的后缀名
            var obj = option.file.name
            var index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + fileType
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/courseAnalyse/${objName}`, option.file).then(res => {
                this.loadingVisible = false;
                // 上传成功之后，转换真实的地址
                signatureUrl(`/ygjy/courseAnalyse/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.form.videoUrl = result;
                    this.form.fileName = option.file.name;
                    this.form.taskName = this.getFileFirstName(option.file.name);
                    this.form.fileName = option.file.name;
                    this.loadingVisible = false;
                })
            })
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await client.multipartUpload(`${ObjName}`, fileUrl, {// 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    // 设置并发上传的分片数量。
                    parallel: 6,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * this.partItemSize,
                })
                // ObjName为文件名字,可以只写名字，就直接储存在 bucket 的根路径，如需放在文件夹下面直接在文件名前面加上文件夹名称
                return result
            } catch (e) {
                if (client) client.cancel();
                this.$message.error('上传失败')
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
        getFileFirstName(name) {
            return name.substring(0,name.lastIndexOf("."));
        },
        checkCourseFile(rule, value, callback){
            if (!this.form.videoUrl) {
                callback(new Error('请上传课程视频'))
            } else {
                callback()
            }
        },
        checkLectureTeacher(rule, value, callback) {
            if (this.$refs.lectureTeacher.checkList.length === 0) {
                callback(new Error('请选择授课教师'))
            } else {
                callback()
            }
        },
        submitForm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.$refs.lectureTeacher.checkList.length !== 0) {
                        this.form.userId = this.$refs.lectureTeacher.checkList[0].userId;
                    }
                    createCourseTask(this.form).then(res => {
                        if (res.data.code === 1) {
                            this.backList()
                        } else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            })
        },
        backList(){
            this.replace('/courseAnalyse')
        },
    }
};
</script>
<style scoped>

.base-create-container{
    width: 100%;
    max-height: calc(100vh - 130px);
    background-color: #fff;
    //padding-bottom: 70px;
    overflow-y: auto!important;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 40px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 40px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: auto;
    padding: 5px 10px 10px 10px;
    box-sizing: border-box;
}
.info-content-container{
    width: 100%;
    height: auto;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #ff7f2e;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}
.topic-title-container2{
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.topic-title-container3{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}

.loading-overlay {
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

::v-deep .el-progress__text {
    font-size: 24px !important;
    color: rgb(30, 160, 225) !important;
}

::v-deep .el-progress-circle {
    width: 150px !important;
    height: 150px !important;
}

.tips_css {
    font-size: 20px;
    color: rgb(30, 160, 225)
}
</style>